import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ProductsPage from "../pages/products/page";
import GuidesPage from "../pages/guides/page";
import CategoriesPage from "../pages/categories/page";
import ReviewPage from "../pages/review/page";
import ShippingPage from "../pages/shipping/page";
import CouponPage from "../pages/coupon/page";
import SafetyPage from "../pages/safety/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import DisclaimerPage from "../pages/disclaimer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/:lang",
    element: <Home />,
  },
  {
    path: "/:lang/spreadsheet/",
    element: <ArticlePage />,
  },
  {
    path: "/:lang/products/",
    element: <ProductsPage />,
  },
  {
    path: "/:lang/categories/",
    element: <CategoriesPage />,
  },
  {
    path: "/:lang/guides/",
    element: <GuidesPage />,
  },
  {
    path: "/:lang/review/",
    element: <ReviewPage />,
  },
  {
    path: "/:lang/shipping/",
    element: <ShippingPage />,
  },
  {
    path: "/:lang/coupon/",
    element: <CouponPage />,
  },
  {
    path: "/:lang/safety/",
    element: <SafetyPage />,
  },
  {
    path: "/:lang/faq/",
    element: <FaqPage />,
  },
  {
    path: "/:lang/about/",
    element: <AboutPage />,
  },
  {
    path: "/:lang/contact/",
    element: <ContactPage />,
  },
  {
    path: "/:lang/privacy/",
    element: <PrivacyPage />,
  },
  {
    path: "/:lang/terms/",
    element: <TermsPage />,
  },
  {
    path: "/:lang/disclaimer/",
    element: <DisclaimerPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;